import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material';
import { AdminBlogPost } from '@app/model/blog-management.model';

interface BlogPostPreviewDialogData {
  post: AdminBlogPost;
}

@Component({
  selector: 'meu-blog-post-preview',
  templateUrl: './blog-post-preview.component.html',
  styleUrls: ['./blog-post-preview.component.scss']
})
export class BlogPostPreviewComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: BlogPostPreviewDialogData,
    private dialogRef: MatDialogRef<BlogPostPreviewComponent>
  ) {}

  get post(): AdminBlogPost {
    return this.data.post;
  }

  closeModal() {
    this.dialogRef.close();
  }
}
